export default __webpack_public_path__ + "static/media/pouting-face.f6ffcd05.svg";